import { render } from "./ChangePasswordPage.vue?vue&type=template&id=a76a3800&ts=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__